import { useEffect, useState } from 'react';

import { t } from 'i18next';
import { useDispatch } from 'react-redux';

import { useChatInsertUsersMutation } from '@school_ify/schoolify-repository/src/student_teacher/types';
import {
  usePossibleParticipantsLazyQuery,
  useChatInsertByTypeGroupMutation,
} from '@school_ify/schoolify-repository/src/shared/types';

import Button from 'components/Button/Button';
import { addConversationIdToParticipants, fetchGroupChats } from 'redux/chat/group_messages.slices';
import { useAppSelector } from 'redux/hooks';
import { getUser } from 'redux/authentication/auth.slice';

import CreateChatModal from './CreateChatModal/CreateChatModal';

interface Props {
  children?: React.ReactNode;
}

const CreateChat: React.FC<Props> = () => {
  const [modal, toggleModal] = useState(false);
  const dispatch = useDispatch();
  const user = useAppSelector(getUser);

  const [chatInsertByTypeGroupMutation] = useChatInsertByTypeGroupMutation();
  const [chatInsertUsersMutation] = useChatInsertUsersMutation();

  const [loadData, { data }] = usePossibleParticipantsLazyQuery({
    variables: {
      id: user.id,
    },
  });

  const createChatHandler = (data, participants) => {
    chatInsertByTypeGroupMutation({
      variables: {
        title: data.title,
        avatar_url: data.avatar_url,
      },
      onCompleted({ insert_chats_one }) {
        const normalizeParticipants = addConversationIdToParticipants(
          participants,
          insert_chats_one.id
        );
        chatInsertUsersMutation({
          variables: {
            participants: normalizeParticipants,
          },
          onCompleted() {
            dispatch(fetchGroupChats());
          },
        });
      },
    });
  };

  // On modal open get all potential participants of a chat room
  useEffect(() => {
    if (modal) {
      loadData();
    }
  }, [loadData, modal]);

  const handleModal = () => {
    toggleModal(prevState => !prevState);
  };

  return (
    <div>
      <CreateChatModal
        openModal={modal}
        handleModal={handleModal}
        data={data?.view_class_student}
        sendData={createChatHandler}
      />
      <div className="show-more flex w-100 justify-center">
        <Button
          onClick={() => {
            toggleModal(true);
          }}
          round
          outlined
          style={{
            backgroundColor: '#fff',
            border: '2px solid #5CD79E',
            width: '80%',
          }}
        >
          {t('chat:Create_Group_Chat')}
        </Button>
      </div>
    </div>
  );
};

export default CreateChat;
